"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataLevelService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const Subject_1 = require("rxjs/Subject");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
//VARIABLE MODELS
const data_level_1 = require("./data-level");
let DataLevelService = class DataLevelService {
    constructor(_http) {
        this._http = _http;
        //declarations
        this.dataLevels = [];
        this.dataLevelsObservable = new Subject_1.Subject();
        this.currentDataLevelSlug = 'all';
        //initializations
        this.dataLevelURL = "/datalevel";
    }
    pull() {
        return this._http.get(this.dataLevelURL)
            .toPromise()
            .then(response => {
            this.dataLevels = JSON.parse(response._body);
            this.dataLevels = this.dataLevels.map(val => {
                val.selected = val.slug == this.currentDataLevelSlug;
                return val;
            });
            this.dataLevelsObservable.next({ dataLevels: this.dataLevels });
        })
            .catch(console.error);
    }
    getAll() {
        return this.dataLevels;
    }
    get() {
        for (let dl in this.dataLevels) {
            if (this.dataLevels[dl].selected) {
                return this.dataLevels[dl];
            }
        }
        return new data_level_1.DataLevel;
    }
    getObservable() {
        return this.dataLevelsObservable.asObservable();
    }
    set(toBe) {
        this.dataLevels = this.dataLevels.map(dl => {
            dl.selected = dl.slug == toBe;
            return dl;
        });
        this.currentDataLevelSlug = toBe;
        return true;
    }
    restrict() {
        return !this.dataLevels.find(dl => { return dl.slug == "all"; }).selected;
    }
};
exports.DataLevelService = DataLevelService;
exports.DataLevelService = DataLevelService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService])
], DataLevelService);
//# sourceMappingURL=data-level.service.js.map